<section class="change-delivery-date">
  <div class="change-delivery-date-header">
    <h2 class="change-delivery-date-title">Modificar fecha de entrega</h2>
    <button
      class="change-delivery-date-close"
      type="button"
      aria-label="Cerrar"
      [disabled]="isSaving"
      (click)="closeDialog()"
    >
      <span class="material-symbols-rounded">close</span>
    </button>
  </div>

  <p class="change-delivery-date-label">Fecha de entrega</p>

  <label for="change-delivery-date" class="sr-only">Fecha de entrega</label>
  <mat-form-field class="change-delivery-date-field" appearance="outline">
    <input id="change-delivery-date"
      matInput
      readonly
      [matDatepicker]="picker"
      [matDatepickerFilter]="dateFilter"
      [min]="minSelectableDate"
      [max]="maxSelectableDate"
      [(ngModel)]="selectedDate"
      (click)="picker.open()"
    />
    <mat-datepicker-toggle matSuffix [for]="picker">
      <mat-icon svgIcon="datepicker_icon" matDatepickerToggleIcon></mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker
      #picker
      panelClass="change-delivery-date-calendar"
      [calendarHeaderComponent]="calendarHeader"
    ></mat-datepicker>
  </mat-form-field>

  <p class="change-delivery-date-note">
    <img src="assets/image/info-icon.svg" alt="" />
    <span
      >Solo puedes programar una nueva fecha posterior mientras el pedido esté en estado Creado.</span
    >
  </p>

  <div class="change-delivery-date-actions">
    <button
      class="change-delivery-date-cancel"
      type="button"
      [disabled]="isSaving"
      (click)="closeDialog()"
    >
      Cancelar
    </button>
    <button
      class="btn-green change-delivery-date-submit"
      type="button"
      [disabled]="isSaving"
      (click)="changeDate()"
    >
      Cambiar fecha
      <mat-spinner
        *ngIf="isSaving; else changeDateIcon"
        diameter="16"
        class="change-delivery-date-spinner"
      ></mat-spinner>
      <ng-template #changeDateIcon>
        <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.43279 13.7311L18.7672 1.51475L17.3508 0L6.45246 10.8L1.43607 5.60656L0 7.0623L6.43279 13.7311Z" fill="white"/>
        </svg>
      </ng-template>
    </button>
  </div>
</section>
